// extracted by mini-css-extract-plugin
export var copyableField = "_ir-4";
export var customerBadge = "_ir-0";
export var customerInfoTitle = "_ir-2";
export var details = "_ir-1";
export var dropdownContainer = "_ir-5";
export var dropdownImage = "_ir-6";
export var editAssigneeForm = "_ir-a";
export var editButton = "_ir-3";
export var email = "_ir-7";
export var hidden = "_ir-d";
export var input = "_ir-8";
export var saveButton = "_ir-b";
export var shopifyIcon = "_ir-c";
export var suggestionBadge = "_ir-e";
export var suggestionText = "_ir-f";
export var username = "_ir-9";